export default function GuestPrompt() {
  return (
    <>
      <h4 className="gradient-text">Vierastunnus</h4>
      <p>Vierastunnukset eivät näe omia tarjouspyyntöjä.</p>
      <p>
        Päästäksesi käsiksi omaan historiaasi, jatka tavallisella tunnuksella
      </p>
    </>
  )
}
